<fieldset [disabled]="!editable">
	<div class="d-flex justify-content-between align-items-center">
		<div class="form-floating mb-3 w-50">
			<input type="text" id="name" class="form-control" name="name" [(ngModel)]="data.name" required />
			<label for="name" class="form-label">Nazwa<small class="ms-2 text-danger">* wymagane</small></label>
		</div>
		<div class="mb-3 w-50 text-center">
			<mat-slide-toggle
				id="isActive"
				name="isActive"
				[disabled]="!editable"
				[(ngModel)]="data.isActive"
				color="primary"
			>
				Wyświetlanie na stronie</mat-slide-toggle
			>
		</div>
	</div>
	<div class="form-floating mb-4">
		<ckeditor
			id="description"
			name="description"
			[(ngModel)]="data.description"
			[editor]="editor"
			[config]="editorConfig"
			[disabled]="!editable"
		></ckeditor>
	</div>
</fieldset>
